import React from 'react';
import { connect } from 'react-redux';
import { userActions } from '../actions';
import { bake_cookie,versionCookie, read_cookie } from '../helpers/cookieHelper';

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    return {
        loggingIn
    };
}

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;
        const { dispatch } = this.props;
        if (username && password) {
            dispatch(userActions.login(username, password));
        }
    }
    
    cookieChecker =()=>{
        const version = read_cookie(versionCookie)
        if(!version){
          bake_cookie(versionCookie,{verlist:[]})
        }
      }

    componentDidMount(){
    this.cookieChecker();
    }

    render() {
        const { loggingIn } = this.props;
        const { username, password, submitted } = this.state;
        return (
            <React.Fragment>
                <div className="bgCloud ">

                    <nav>
                        <div className="wrapper " id="wrapper">
                            <div className="mainmenu">
                                <div className="mainmenubtn-s">
                                    <a className="leftbtn" id="toggle-sidebar"><span className="icon-menu-options"></span></a>
                                </div>
                                <div id="main-sidebar" className="main-sidebar main-sidebar-left">
                                    <div className="main-sidebar-wrapper">
                                        <div>
                                            <ul>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="container">
                                    <div className="mainlogo">
                                        <a href="">
                                        </a>
                                    </div>
                                    
                                    <div className="menu-area">
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>


                    <div className="mainContent ">

                        <div className="container ">
                            <div className="titleName animated fadeInDown">登入</div>
                        </div>

                        <div className="containerBox">
                            <div className="container">
                                <div className="bgContact">
                                    <div className="contactBox animated fadeInDown">
                                        <div className="contactBoxB">
                                            <h6>LOWI Login</h6>
                                            <form name="form" onSubmit={this.handleSubmit}>
                                                <div className="form-group form-inline">
                                                    <div className="col-md-12">
                                                        <input placeholder="請輸入帳號" type="text" name="username" value={username} onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="form-group form-inline">
                                                    <div className="col-md-12">
                                                        <input type="password" placeholder="請輸入密碼" name="password" value={password} onChange={this.handleChange}/>
                                                    </div>
                                                </div>                                        
                                                <div className="form-group form-inline">
                                                    <div className="col-md-12">
                                                        <button className="redBtn pointer-button">送&nbsp;&nbsp;出</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                    </div>


                    <footer>
                        <div className="redFooter">
                            <div className="container">
                                是方電訊股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;台北市114內湖區瑞光路68號2樓&nbsp;&nbsp;&nbsp;&nbsp;070-1018-6688&nbsp;&nbsp;&nbsp;&nbsp;02-2657-6688
                                <span className="redRight">Copyright @ 2019 Chief Telecom Inc. All Rights Reserved.</span>
                            </div>
                        </div>
                    </footer>

                </div>
            </React.Fragment>
        );
    }
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };



// WEBPACK FOOTER //
// ./src/components/LoginPageCHIEF.js